export const VerifyAccountPopupRoutes = {
  VERIFY_ACCOUNT: '/verify-account',
  VERIFY_ACCOUNT_REMINDERS: '/verify-account-reminders'
};
